<div [formGroup]="form()">
  <div class="d-flex justify-content-center align-items-center photo">
    @for (nonce of [photoNonce()]; track nonce) {
      <ct-lib-image-editor
        [imageSrc]="photoSrc()"
        [ratio]="2 / 3"
        [accept]="'image/png, image/jpeg'"
        (confirmed)="onPhotoConfirm($event)"
        (deleted)="onPhotoDelete()"
      >
        @if (!photoSrc() && photoInitials()) {
          <app-platform-avatar-placeholder
            imageEditorEmpty
            class="photo-avatar"
            [initials]="photoInitials()!"
          ></app-platform-avatar-placeholder>
        }
      </ct-lib-image-editor>
    }
  </div>
  <div class="row">
    <div class="col-12 col-md-6 form-group form-floating">
      <ng-select
        class="form-control"
        formControlName="title"
        [searchable]="false"
        [clearable]="false"
        id="profileTitle"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
      >
        @for (
          salutation of constantsService.getLabelValueArray(constantsService.salutationConstants);
          track salutation.value
        ) {
          <ng-option [value]="salutation.value">
            {{ salutation.label | transloco }}
          </ng-option>
        }
      </ng-select>
      <label for="profileTitle">{{
        'jobboard.platform.profile.sections.contact.salutation' | transloco
      }}</label>
    </div>
    <div class="col-12 col-md-6 form-group form-floating">
      <ng-select
        class="form-control"
        formControlName="academicTitle"
        [searchable]="false"
        [clearable]="false"
        id="profileAcademicTitle"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
      >
        @for (
          academicTitle of constantsService.getLabelValueArray(
            constantsService.academicTitleConstants
          );
          track academicTitle.value
        ) {
          <ng-option [value]="academicTitle.value">
            {{ academicTitle.label | transloco }}
          </ng-option>
        }
      </ng-select>
      <label for="profileAcademicTitle">{{
        'jobboard.platform.profile.sections.contact.academic-title' | transloco
      }}</label>
    </div>
    <div
      class="col-12 col-md-6 form-group form-floating"
      [class.invalid]="
        form().controls['firstName'].invalid &&
        (form().controls['firstName'].dirty || submitAttempt())
      "
    >
      <input
        type="text"
        class="form-control"
        formControlName="firstName"
        id="profileFirstName"
        [placeholder]="'jobboard.platform.profile.sections.contact.first-name' | transloco"
        maxlength="30"
      />
      <label for="profileFirstName">{{
        'jobboard.platform.profile.sections.contact.first-name' | transloco
      }}</label>
      @if (
        form().controls['firstName'].invalid &&
        (form().controls['firstName'].dirty || submitAttempt())
      ) {
        <div class="validation">
          <p>{{ 'jobboard.platform.profile.sections.contact.name-invalid' | transloco }}</p>
        </div>
      }
    </div>
    <div
      class="col-12 col-md-6 form-group form-floating"
      [class.invalid]="
        form().controls['lastName'].invalid &&
        (form().controls['lastName'].dirty || submitAttempt())
      "
    >
      <input
        type="text"
        class="form-control"
        formControlName="lastName"
        id="profileLastName"
        [placeholder]="'jobboard.platform.profile.sections.contact.last-name' | transloco"
        maxlength="30"
      />
      <label for="profileLastName">{{
        'jobboard.platform.profile.sections.contact.last-name' | transloco
      }}</label>
      @if (
        form().controls['lastName'].invalid &&
        (form().controls['lastName'].dirty || submitAttempt())
      ) {
        <div class="validation">
          <p>{{ 'jobboard.platform.profile.sections.contact.name-invalid' | transloco }}</p>
        </div>
      }
    </div>
    <div class="col-12 col-md-6 form-group form-floating">
      <input
        type="text"
        class="form-control"
        formControlName="currentOccupation"
        id="profileOccupation"
        [placeholder]="'jobboard.platform.profile.sections.contact.occupation' | transloco"
      />
      <label for="profileOccupation">{{
        'jobboard.platform.profile.sections.contact.occupation' | transloco
      }}</label>
    </div>
    <div class="col-12 col-md-6 form-group form-floating">
      <ng-select
        class="form-control"
        formControlName="city"
        [items]="cityItems()"
        [loading]="citiesLoading()"
        [typeahead]="cityInput$"
        [minTermLength]="2"
        [typeToSearchText]="'jobboard.platform.profile.sections.contact.city-search-text' | transloco"
        [notFoundText]="'ct-library.constants.ng-select.placeholders.not-found' | transloco"
        [clearable]="true"
        [placeholder]="'jobboard.platform.profile.sections.contact.city' | transloco"
        id="profileCity"
        (change)="onCityChange($event)"
        (clear)="onCityClear()"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ cityLabel() || item }}
        </ng-template>
      </ng-select>
      <label for="profileCity">{{
        'jobboard.platform.profile.sections.contact.city' | transloco
      }}</label>
    </div>
    <div class="col-12 col-md-6 form-group form-floating">
      <input
        type="email"
        class="form-control"
        formControlName="email"
        id="profileEmail"
        readonly
        [placeholder]="'jobboard.platform.profile.sections.contact.email' | transloco"
      />
      <label for="profileEmail">{{
        'jobboard.platform.profile.sections.contact.email' | transloco
      }}</label>
      <p class="hint text-muted">{{
        'jobboard.platform.profile.sections.contact.email-hint' | transloco
      }}</p>
    </div>
    <div
      class="col-12 col-md-6 form-group form-floating"
      [class.invalid]="
        form().controls['phone'].invalid &&
        (form().controls['phone'].dirty || submitAttempt())
      "
    >
      <input
        type="tel"
        class="form-control"
        formControlName="phone"
        id="profilePhone"
        [placeholder]="'jobboard.platform.profile.sections.contact.phone' | transloco"
      />
      <label for="profilePhone">{{
        'jobboard.platform.profile.sections.contact.phone' | transloco
      }}</label>
      @if (
        form().controls['phone'].invalid &&
        (form().controls['phone'].dirty || submitAttempt())
      ) {
        <div class="validation">
          <p>{{ 'jobboard.platform.profile.sections.contact.phone-invalid' | transloco }}</p>
        </div>
      }
    </div>
  </div>
</div>
